import type { CompanyArtistType as ApiCompanyArtistType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../../../common';
import type { CompanyArtistType } from '../../types';
import { mapCompanyArtistContactType } from '../mapCompanyArtistContactType';

export const mapCompanyArtistType = (
  api: ApiCompanyArtistType
): CompanyArtistType => ({
  artist: mapLinkableEntityType(api.artist),
  contacts: api.contacts.map(mapCompanyArtistContactType),
});
